import { createFileRoute } from "@tanstack/react-router"
import { useTranslation } from "react-i18next"

import { SupportTable } from "@/features/support/components/SupportTable"

// Bilinçli guard'sız (B-024): org login'ler de destek görür — veri server-side
// scope'lanır (talep, atanmış birimi caller alt ağacındaysa görünür; köke
// devredilenleri yalnız admin görür). Nav item'ı da canAccess'siz (nav-config).
export const Route = createFileRoute("/_authed/support")({
  component: SupportPage,
})

function SupportPage() {
  const { t } = useTranslation("support")
  return (
    <div className="h-full flex flex-col min-h-0">
      <div className="border-b border-ok-border px-6 py-4">
        <h1 className="text-lg font-semibold tracking-tight">{t("title")}</h1>
        <p className="text-xs text-ok-foreground-muted">{t("subtitle")}</p>
      </div>
      <SupportTable />
    </div>
  )
}
